export const SET_ERRORS = 'PROFILE_SET_ERRORS';

export function setErrors(errors, elementId) {
    return {
        type: SET_ERRORS,
        elementId,
        payload: errors,
    };
};
